import { render, staticRenderFns } from "./radio-form.vue?vue&type=template&id=6e78c787&scoped=true"
import script from "./radio-form.vue?vue&type=script&lang=ts"
export * from "./radio-form.vue?vue&type=script&lang=ts"
import style0 from "./radio-form.vue?vue&type=style&index=0&id=6e78c787&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78c787",
  null
  
)

export default component.exports